var render = function render(_c,_vm){return _c('div',{staticClass:"py-3"},[_vm._v(_vm._s(_vm.props.item.quantityPicked || _vm.props.item.quantityOrdered))])
}
var staticRenderFns = []

export { render, staticRenderFns }